

















import {
    dissmissFeatureTestingDisclaimer,
    getTestedFeatures,
} from '@src/app/utils/featureTesting';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'FeatureTestingDisclaimer',
    setup() {
        function dismissDisclaimer() {
            dissmissFeatureTestingDisclaimer();
        }

        return {
            testedFeatures: getTestedFeatures(),
            dismissDisclaimer,
        };
    },
    components: {
        SdsIcon,
    },
});
